export default __webpack_public_path__ + "e72a11df3df8e8a1347be59053a14ceb.png";